import { array, boolean, defineAction, enumerated, number, object, string } from '~/prix'
import any from '~/prix/types/any'
import generateItinerarySentinel from './generateItinerarySentinel.action.json'

const Feature = object({
  type: string(),
  geometry: object({
    type: string(),
    coordinates: array(object({})),
  }),
  properties: array(object({})).isOptional(),
})

const FeatureCollection = object({
  type: string().value('FeatureCollection'),
  feature: array(Feature),
  properties: array(object({})).isOptional(),
})

const generateItinerarySentinelDefinition = defineAction({
  ...generateItinerarySentinel,
  input: object({
    geoId: number().isOptional(),
    level: string().isOptional(),
    latitude: number().isOptional(),
    longitude: number().isOptional(),
    sizes: array(string()).isOptional(),
    segments: array(string()).isOptional(),
    registrationStatuses: array(
      enumerated({
        active: 'Ativo',
        inapt: 'Inapto',
        suspended: 'Suspenso',
        extinct: 'Extinto',
      }),
    ).isOptional(),
    ageGroups: array(
      enumerated({
        startup: 'Startup',
        young: 'Jovem',
        growth: 'Crescimento',
        established: 'Estabelecida',
      }),
    ).isOptional(),
    requiresFampeMembership: boolean().isOptional(),
    currentYearAppSebraeAttendanceCount: number().isOptional(),
    agentPolygonCpf: string().isOptional(),
    targetPolygon: any().isOptional(),
  }),
  output: object({
    itineraries: array(FeatureCollection),
    attendantsInTheArea: array(
      object({
        attendantId: string(),
        attendantName: string(),
        attendantCpf: string(),
      }),
    ),
    warnings: array(string()),
  }),
})

export default generateItinerarySentinelDefinition
